import * as React from 'react';
import cn from 'classnames';

import { MinusIcon, SelectIcon } from 'shared/newComponents/icons';
import WithBorder from 'shared/newComponents/WithBorder';
import { useModalState } from 'shared/entities/common/hooks';
import { IconSize } from 'shared/entities/components/Icon';

import './IndeterminateCheckbox.modules.scss';

type Props = {
  value: boolean;
  indeterminate: boolean;
  onChange: (
    value: boolean,
    originalEvent: React.MouseEvent<HTMLDivElement>
  ) => void;
  disabled?: boolean;
  className?: string;
};

const IndeterminateCheckbox: React.FC<Props> = ({
  value,
  indeterminate,
  onChange,
  disabled,
  className
}: Props) => {
  const { opened: focused, open: focus, close: unfocus } = useModalState();

  const handleChange = React.useCallback<
    React.MouseEventHandler<HTMLDivElement>
  >(
    (event) => {
      onChange(!value, event);
    },
    [onChange, value]
  );

  const showIcon = value || indeterminate;
  const Icon = indeterminate ? MinusIcon : SelectIcon;

  return (
    <div styleName="indeterminate-checkbox" className={className}>
      <div
        tabIndex={0}
        onFocus={focus}
        onBlur={unfocus}
        onClick={handleChange}
        styleName={cn(
          'indeterminate-checkbox__control',
          disabled && 'indeterminate-checkbox__control_disabled'
        )}
      >
        <div styleName="indeterminate-checkbox__border-wrap">
          <WithBorder focus={focused} disabled={disabled} borderRadius={4}>
            <div styleName="indeterminate-checkbox__box">
              <div
                styleName={cn(
                  'indeterminate-checkbox__icon',
                  showIcon && 'indeterminate-checkbox__icon_visible',
                  disabled && 'indeterminate-checkbox__icon_disabled',
                  indeterminate && 'indeterminate-checkbox__icon_indeterminate'
                )}
              >
                <Icon iconSize={IconSize.XSM} />
              </div>
            </div>
          </WithBorder>
        </div>
      </div>
    </div>
  );
};

export default React.memo(IndeterminateCheckbox);
